import { cn } from '@/lib/utils';

interface QuotePreviewThumbnailsProps {
  numPages: number;
  currentPage: number;
  onPageChange: (page: number) => void;
}

export const QuotePreviewThumbnails = ({ 
  numPages, 
  currentPage, 
  onPageChange 
}: QuotePreviewThumbnailsProps) => {
  if (numPages <= 1) return null;
  
  return (
    <div className="flex items-center justify-center gap-2 py-2">
      {Array.from({ length: numPages }, (_, i) => i + 1).map((pageNum) => (
        <button
          key={pageNum}
          onClick={() => onPageChange(pageNum)}
          className={cn(
            "w-10 h-14 rounded border-2 flex items-center justify-center text-xs font-medium transition-all",
            currentPage === pageNum
              ? "border-primary bg-primary/10 text-primary"
              : "border-muted-foreground/30 bg-muted/50 text-muted-foreground hover:border-muted-foreground hover:bg-muted"
          )}
          title={`Pagina ${pageNum}`}
        >
          {pageNum}
        </button>
      ))}
    </div>
  );
};
